import axios from "axios";
import { handleAxiosErrors, getRessource } from "../utils";

const MARCHE = "/marche";
const GET_ZA_MARCHES = `${MARCHE}/get-za-marches`;

export const getMarchesZa = (codesReseau, abort) =>
  axios
    .get(GET_ZA_MARCHES, {
      params: {
        codesReseau,
      },
      signal: abort.signal,
    })
    .then(response => handleAxiosErrors(response))
    .then(url => getRessource(url, abort))
    .catch(error => Promise.reject(error));
